export default {
  SET_TAGS(state, payload) {
    state.tags = payload;
  },
  ADD_TAG(state, payload) {
    //state.tags = {state.tags, ...payload};
    // console.log(payload)
    state.tags.unshift(payload);
  },
  DELETE_TAG(state, payload) {
    const index = state.tags.findIndex((page) => page._id === payload._id);
    state.tags.splice(index, 1);
  },

  SET_CATEGORYWISEPAGE(state, payload) {
    state.categorywisepages = payload;
  },
  EDIT_TAG(state, payload) {
    const index = state.tags.findIndex((page) => page._id === payload._id);
    state.tags.splice(index, 1, payload);
  },
  SET_SELECT_TAG(state, payload) {
    state.select_tag = payload;
  },
};
